import { createContext, RefObject, useContext } from "react";

import { getLocationType, locationType } from "@models/services/organisation";
import { userProfile } from "@models/services/user";
import { ContactDetailsType } from "@models/shared/shared.model";

export type LocationContextType = {
  locationDetails: getLocationType | undefined;
  activeLocation: locationType | null;
  userProfile: userProfile | undefined;
  contactPersonDetails: ContactDetailsType | undefined;
  paymentRef: RefObject<HTMLDivElement | null> | null;
  pricingRef: RefObject<HTMLDivElement | null> | null;
};

const defaultLocationContext: LocationContextType = {
  activeLocation: null,
  contactPersonDetails: undefined,
  locationDetails: undefined,
  paymentRef: null,
  pricingRef: null,
  userProfile: undefined,
};

export const LocationContext = createContext<LocationContextType>(
  defaultLocationContext
);

export const useLocationContext = () => useContext(LocationContext);
